import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const PageLoader = ({ loading, loadingLabel }) => {
  const theme = useTheme();

  return (
    <Backdrop
      sx={{
        zIndex: theme.zIndex.modal
      }}
      open={loading}
    >
      <Stack
        sx={{
          direction: 'column',
          display: 'flex'
        }}
      >
        <CircularProgress color="primary" sx={{ margin: 'auto' }} />
        {loadingLabel && (
          <Typography
            variant="bookPreview"
            component="h1"
            color="primary"
            sx={{
              mt: 2,
              textAlign: 'center',
              fontSize: '2rem'
            }}
          >
            {loadingLabel}
          </Typography>
        )}
      </Stack>
    </Backdrop>
  );
};

PageLoader.defaultProps = {
  loading: false,
  loadingLabel: null
};

PageLoader.propTypes = {
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string
};

export default PageLoader;
